export interface ClientConfig {
  apigHost: string,
  apiRegion: string,
  appClientId: string,
  authRegion: string,
  googleMapsApiKey: string | null,
  incomingMediaBucket: string,
  cognitoEndpoint: string,
  userPoolId: string,
  awsAccountId: string,
  // Cognito App Client id for the MCP OAuth surface (the `mimir-mcp-public`
  // client, distinct from `appClientId` which is the SPA's client). Optional
  // — stages that haven't deployed the MCP IaC will omit it. Integrators
  // building an MCP-style client should prefer this when present.
  mcpAppClientId?: string,
}

export const isClientConfig = (obj: unknown): obj is ClientConfig => {
  if (obj == null || typeof obj !== 'object') {
    return false;
  }
  const cc = obj as Partial<ClientConfig>;
  return cc.appClientId != null;
};
